export const WhatsAppIcon = ({ className = "", strokeWidth = 1.6, ...rest }) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} className={className} aria-hidden {...rest}>
        <path d="M3.5 20.5l1.3-4.2a8 8 0 1 1 3.2 3.1L3.5 20.5z" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.5 9.5c.3-.9 1.3-1 1.6-.1l.4 1.2c.1.3 0 .6-.2.8l-.6.5c.6 1.3 1.6 2.3 2.9 2.9l.5-.6c.2-.2.5-.3.8-.2l1.2.4c.9.3.8 1.3-.1 1.6-.8.3-1.7.3-2.5-.1-2-.9-3.6-2.5-4.5-4.5-.4-.8-.4-1.7-.1-2.5z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default WhatsAppIcon;
